// 标记
export default {
    marker: 'клеймо',
    folder: 'клеймо',
    creationTime: 'время создания',
    sameDay: 'В тот же день',
    thisWeek: 'на этой неделе',
    thisMonth: 'этот месяц',
    thisYear: 'в этом году',
    all: 'все',
    place: 'место проведения',
    addPoints: 'Добавить точку',
    addLine: 'Добавить строку',
    addPolygon: 'Добавить область',
    markerInfo: 'Маркировочная информация',
    lng: 'долгота',
    lat: 'широта',
    alt: 'высота',
    color: 'цвет',
    icon: 'Значки',
    remarks: 'Примечание',
    unnamedLine: 'безымянная линия',
    linetype: 'линейная форма',
    lineWidth: 'ширина линии',
    solidLine: 'сплошная линия',
    dottedLine: 'пунктир',
    dashDot: 'штриховка',
    transparent: 'прозрачность',
    arrowPosition: 'позиция стрелки',
    startingPoint: 'Начало',
    end: 'конец',
    arrowDirection: 'направление стрелки',
    forward: 'прямое направление',
    reverse: 'обратный',
    shape: 'форма',
    unnamedFaces: 'безымянный поверхность',
    sideLength: 'длина края',
    long: 'длина',
    wide: 'ширина',
    numberSides: 'боковое число',
    radius: 'радиус',
    cancel: 'отмена',
    complete: 'выполнить',
    clickCut: 'начать кройку',
    areaName: 'имя области',
    enterName: 'Введите имя области',
    enterContent: 'Введите содержимое',
    save: 'Сохранить',
    delete: 'Удалить',
    originalArea: 'первичная область',
    determine: 'определение',
    tips: 'подсказка',
    search:'поиск',
    importKML:'Импорт KML',
    exportKML:'Экспорт KML',
    addFolders:'Добавить папку',
    share:'делить',
    unnamedPoint:'безымянная точка',
    enterNameSearch:'Введите имя для поиска',
    fileImport:'Файл Импорт',
    destinationFolder:'целевая папка',
    edit:'редактор',
    showHide:'Показать / скрыть',
    createdBy:'createdBy',
    editFolder:'Изменить папку',
    addFolder:'Создать папку',
    enterFolderName:'Введите имя папки',
    quickSharing:'быстрый обмен',
    onlineEquipment:'подключённое устройство',
    uav:'беспилотный человек',
    rtkStation:'RTK (станция метро)',
    refresh:'Обновить',
    copy:'копировать',
    use:'использование',
    sharedUsers:'общий пользователь',
    more:'больше',
    pleaseSelect:'Выберите',
    nothing:'Нет',
    folderName:'Имя папки',
    triangle:'треугольник',
    rectangle:'прямоугольник',
    polygon:'многоугольник',
    circular:'круг',
    free:'свобода',
    enterDeviceSearch:'Введите имя устройства для поиска',
    notLocated:'неподвижный',
    singlePointPositioning:'одноточечное позиционирование',
    diffPositioning:'дифференциальная локация',
    fixedUnposition:'фиксированное решение',
    floatingPointRelocation:'определение места с плавающей запятой',
    inertialNavigationPositioning:'инерционное позиционирование',
    setPositioning:'Настройка локализации',
    noPositioning:'отсутствие ориентировки',
    gpsPositioningError:'ошибка GPS',
    rtkSinglePointPositioning:'одноточечное решение RTK',
    rtkDiffPositioning:'определение места расщепления RTK',
    rtkFloatingPointRelocation:'определение места с плавающей запятой RTK',
    rtkFixedPositioning:'Решение фиксации RTK',
    gpsPositioning:'GPS - локализация',
    mobilePhone:'мобильный телефон',
    importRouteList:'Импорт списка маршрутов',
    delTip:'Отметка не может быть восстановлена после удаления, продолжается ли?',
    pleaseSelectAtLeastOneTag:'Выберите хотя бы одну метку',
    sharingSuccessful:'Поделиться Успехом',
    markingSurface:'Маркировочная поверхность',
    dbclickCut:'Двойной щелчок по карте или нажатие на последнюю точку для завершения обрезки',
    cutAtLeastOnce:'Вырезать хотя бы раз.',
    markingLine:'Линия разметки',
    markPoint:'Точка маркировки'
}
